import { gql } from "@apollo/client"

export const MUTATION_UPDATE_THEME_INTEREST = gql`
  mutation UpdateThemeOfInterest(
    $themeOfInterestId: String!
    $title: String!
    $description: String!
    $url: String!
    $background: Upload
    $image: Upload
  ) {
    updateThemeOfInterest(
      themeOfInterestId: $themeOfInterestId
      title: $title
      description: $description
      url: $url
      background: $background
      image: $image
    ) {
      message
      data {
        id
      }
    }
  }
`
